var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 10,
    r: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 0C8.31629 0 3.69189 4.6244 3.69189 10.3085C3.69189 11.7911 3.99535 13.2067 4.59339 14.5162C7.17065 20.1559 12.112 26.1102 13.5654 27.8006C13.6743 27.9269 13.833 27.9997 14.0001 27.9997C14.1671 27.9997 14.3259 27.9269 14.4348 27.8006C15.8876 26.1105 20.8289 20.1565 23.4071 14.5162C24.0054 13.2067 24.3086 11.7911 24.3086 10.3085C24.308 4.6244 19.6836 0 13.9998 0ZM13.9998 15.6627C11.0474 15.6627 8.64526 13.2605 8.64526 10.3082C8.64526 7.35554 11.0474 4.95336 13.9998 4.95336C16.9522 4.95336 19.3543 7.35554 19.3543 10.3082C19.3546 13.2605 16.9524 15.6627 13.9998 15.6627Z",
    fill: "#546587"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.49f0badd57532596af983bbac0cb9e69.svg";
export { ForwardRef as ReactComponent };